"use client";

import { cn } from "@/lib/utils";
import useTranslate from "@app/_hooks/useTranslate";
import { ComponentProps } from "react";

export default function ProductCardVariants({
  count,
  className,
  ...props
}: { count: number } & ComponentProps<"span">) {
  const t = useTranslate();

  if (count <= 1) {
    return null;
  }

  return (
    <span
      className={cn(
        "absolute right-0 bottom-0 p-2 text-sm",
        className,
      )}
      {...props}
    >
      {t("moreVariants")}
    </span>
  );
}

ProductCardVariants.displayName = "ProductCardVariants";
